import axios from "axios";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./Style/globalValidasiEror.scss";
import Url from "../global";

const FormAddRiwayatPendidikan = () => {
  const [tingkatPendidikan, setTingkatPendidikan] = useState("");
  const [nomorIjazah, setNomorIjazah] = useState("");
  const [tglLulus, setTglLulus] = useState("");
  const [tempatSekolah, setTempatSekolah] = useState("");
  const [jurusan, setJurusan] = useState("");
  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const [sertifikasi, setSertifikasi] = useState("");
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);

  const [fileSertifikasi, setFileSertifikasi] = useState(null);
  const [fileUrlSertifikasi, setFileUrlSertifikasi] = useState(null);

  const [setError] = useState(null);

  const PdfViewer = ({ fileUrl }) => {
    return (
      <div>
        {fileUrl ? (
          <embed
            src={fileUrl}
            type="application/pdf"
            width="70%"
            height="600px"
          />
        ) : (
          <p>No PDF file uploaded</p>
        )}
      </div>
    );
  };

  const PdfViewerSertifikasi = ({ fileUrlSertifikasi }) => {
    return (
      <div>
        {fileUrlSertifikasi ? (
          <embed
            src={fileUrlSertifikasi}
            type="application/pdf"
            width="70%"
            height="600px"
          />
        ) : (
          <p>No PDF file uploaded</p>
        )}
      </div>
    );
  };

  const {
    register,
    reset,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
    } else {
      setFile(null);
      setError("File harus berupa PDF");
    }
  };

  const handleChangeSertifikasi = (e) => {
    const selectedFileSertifikasi = e.target.files[0];

    if (
      selectedFileSertifikasi &&
      selectedFileSertifikasi.type === "application/pdf"
    ) {
      setFileSertifikasi(selectedFileSertifikasi);
      setFileUrlSertifikasi(URL.createObjectURL(selectedFileSertifikasi));
    } else {
      setFileSertifikasi(null);
      setError("File harus berupa PDF");
    }
  };

  const saveRiwayatPendidikan = async (e) => {
    if (file) {
      const formData = new FormData();
      formData.append("strTingkatPendidikan", tingkatPendidikan);
      formData.append("strNoIjazah", nomorIjazah);
      formData.append("dateTglLulus", tglLulus);
      formData.append("strTempatSekolah", tempatSekolah);
      formData.append("strJurusan", jurusan);
      formData.append("strStatus", status);
      formData.append("strSertifikasi", sertifikasi);
      formData.append("pdfFile", file);
      formData.append("pdfFileSertifikasi", fileSertifikasi);

      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }

      // for (let i = 0; i < fileSertifikasi.length; i++) {
      //   formData.append("files", fileSertifikasi[i]);
      // }

      try {
        await axios.post(`${Url}/riwayat_pendidikans`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        });
        navigate("/riwayat-pendidikan");
        reset();
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    }
  };

  return (
    <div>
      <h1 className="title">Riwayat Pendidikan</h1>
      <h2 className="subtitle">Add New Riwayat Pendidikan</h2>

      <div className="card is-shadowless">
        <div className="card-content">
          <div className="content">
            <form
              className="box"
              onSubmit={handleSubmit(saveRiwayatPendidikan)}
            >
              <p className="has-text-centered">{msg}</p>

              <div className="field">
                <label className="label">Tingkat Pendidikan</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={tingkatPendidikan}
                      onChange={(e) => setTingkatPendidikan(e.target.value)}
                      required
                    >
                      <option>------Pilih------</option>
                      <option>SMP</option>
                      <option>SMA</option>
                      <option>D1</option>
                      <option>D2</option>
                      <option>D3</option>
                      <option>D4</option>
                      <option>S1</option>
                      <option>S1/Profesi</option>
                      <option>S1</option>
                      <option>S2</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Nomor Ijazah</label>
                <div className="control">
                  <input
                    className={`input ${errors.nomorIjazah && "invalid"}`}
                    {...register("nomorIjazah", {
                      required: {
                        value: true,
                        message: "Nomor Ijazah Wajib Di isi!",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("nomorIjazah");
                    }}
                    placeholder="Nomor Ijazah"
                    value={nomorIjazah}
                    onChange={(e) => setNomorIjazah(e.target.value)}
                  />
                  {errors.nomorIjazah && (
                    <small className="allValidasiError">
                      {errors.nomorIjazah.message}
                    </small>
                  )}
                </div>
              </div>
              <div className="field">
                <label className="label">Tanggal Lulus</label>
                <div className="control">
                  <Form.Group controlId="duedate" className="dtp">
                    <Form.Control
                      type="date"
                      name="duedate"
                      placeholder="Tanggal Lulus"
                      value={tglLulus}
                      onChange={(e) => setTglLulus(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="field">
                <label className="label">Nama Sekolah</label>
                <div className="control">
                  <input
                    type="text"
                    className={`input ${errors.tempatSekolah && "invalid"}`}
                    {...register("tempatSekolah", {
                      required: {
                        value: true,
                        message: "Nama Sekolah Wajib Di isi!",
                      },
                      minLength: {
                        value: 5,
                        message: "minimal 5 karakter",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("tempatSekolah");
                    }}
                    placeholder="Nama Sekolah"
                    value={tempatSekolah}
                    onChange={(e) => setTempatSekolah(e.target.value)}
                  />

                  {errors.tempatSekolah && (
                    <small className="allValidasiError">
                      {errors.tempatSekolah.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="field">
                <label className="label">Jurusan</label>
                <div className="control">
                  <input
                    type="text"
                    // className={`input ${errors.jurusan && "invalid"}`}
                    // {...register("jurusan", {
                    //   required: {
                    //     value: true,
                    //     message: "Jurusan Wajib Di isi!",
                    //   },
                    //   minLength: {
                    //     value: 5,
                    //     message: "minimal 5 karakter",
                    //   },
                    // })}
                    className="input"
                    placeholder="Jurusan"
                    value={jurusan}
                    onChange={(e) => setJurusan(e.target.value)}
                  />
                  {/* {errors.jurusan && (
                    <small className="allValidasiError">
                      {errors.jurusan.message}
                    </small>
                  )} */}
                </div>
              </div>

              <div className="field">
                <label className="label">Status Pendidikan</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      disabled="true"
                    >
                      <option>Pengajuan Sertifikat Pendidikan</option>
                      <option>Disetujui Kabid Kepegawaian</option>
                      <option>Ditolak Kabid Kepegawaian</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Sertifikasi</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={sertifikasi}
                      onChange={(e) => setSertifikasi(e.target.value)}
                      required
                    >
                      <option>------Pilih------</option>
                      <option value="Belum Sertifikasi">
                        Belum Sertifikasi
                      </option>
                      <option value="Sudah Sertifikasi">
                        Sudah Sertifikasi
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Ijazah dan Transkrip Nilai</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleChange}
                      />
                      {/* <button type="submit">Upload</button> */}
                    </label>
                  </div>
                  <br />
                  <PdfViewer fileUrl={fileUrl} />
                </div>
              </div>

              {sertifikasi === "Sudah Sertifikasi" && (
                <div className="field">
                  <label className="label">Sertifikasi</label>
                  <div className="control">
                    <div className="file">
                      <label className="file-label">
                        <input
                          type="file"
                          accept="application/pdf"
                          onChange={handleChangeSertifikasi}
                        />
                        {/* <button type="submit">Upload</button> */}
                      </label>
                    </div>
                    <br />
                    <PdfViewerSertifikasi
                      fileUrlSertifikasi={fileUrlSertifikasi}
                    />
                  </div>
                </div>
              )}
              <br />
              <div className="field">
                <div className="control">
                  <button type="submit" className="button is-success">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAddRiwayatPendidikan;
